/* eslint-disable */
export default {
  logged: 'Connesso',
  unlogged: 'Non elaborato',
  faxNotSupported: 'Registro fax non supportato.',
} as const;

// @key: @#@"logged"@#@ @source: @#@"Logged"@#@
// @key: @#@"unlogged"@#@ @source: @#@"Unworked"@#@
// @key: @#@"faxNotSupported"@#@ @source: @#@"To log fax is not supported."@#@
